<!-- 组件说明 -->
<template>
    <div class="queryRecord">
        <notice showIcon
            >温馨提示：排名查询记录只保留<em class="orangeFont"> 15 </em>，15天后系统将自动清除，请及时查看记录</notice
        >
        <div class="query-Record-content" v-loading="loading">
            <div class="searchBar dfc">
                <div class="search-item">
                    <span>关键词：</span>
                    <el-input v-model="keyWord" size="small" placeholder="请输入关键词" class="w220" />
                </div>
                <div class="search-item ml20">
                    <span>类型：</span>
                    <el-select v-model="searchType" class="w220" size="small">
                        <el-option
                            v-for="(item, index) in searchTypeList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </div>
                <div class="search-item ml20">
                    <span>查询时间：</span>
                    <el-date-picker
                        v-model="dateRangeTime"
                        size="small"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                    />
                </div>
                <el-button class="ml20 w120" type="primary" size="small" @click="search">查询</el-button>
            </div>
            <div class="table mt20">
                <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeader">
                    <el-table-column label="查询时间">
                        <template #default="{ row }">
                            <span>{{ row.createTime | formatTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="类型">
                        <template #default="{ row }">
                            <span>{{ row.queryTypeText }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="关键词" min-width="260">
                        <template #default="{ row }">
                            <span>{{ row.keyWords.join('，') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="查询页数">
                        <template #default="{ row }">
                            <span>{{ row.queryPage === 1 ? '1-60个' : '1-200个' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品链接">
                        <template #default="{ row }">
                            <div :title="row.queryLink ? row.queryLink : '--'" style="width: 100%" class="textOver">
                                {{ row.queryLink ? row.queryLink : '--' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="店铺名称">
                        <template #default="{ row }">
                            <span>{{ row.shopName ? row.shopName : '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" header-align="center" width="90">
                        <template #default="{ row }">
                            <el-button type="text" @click="checkDetail(row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tr mt10">
                    <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        background
                        layout="prev, pager, next,total, jumper"
                        :total="query.totalCount"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </div>
        <checkDetail ref="checkDetail" />
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import notice from './../../../components/notice/index.vue';
import dayjs from 'dayjs';
import checkDetail from './components/checkDetail.vue';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { notice, checkDetail },
    filters: {
        formatTime(val) {
            if (val === '' || val === null || val === undefined) {
                return '';
            }
            return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    data() {
        return {
            keyWord: '',
            searchType: '',
            searchTypeList: [
                {
                    label: '全部',
                    value: '',
                },
                {
                    label: '全店产品排名查询',
                    value: 1,
                },
                {
                    label: '单产品排名查询',
                    value: 2,
                },
                {
                    label: '关键词排名查询',
                    value: 3,
                },
            ],

            dateRangeTime: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date(dayjs().format('YYYY-MM-DD') + ' 00:00:00');
                },
            },
            tableData: [],
            tableHeader: {
                background: '#f4f4f4',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            },
            query: {
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
            },
            loading: false,
        };
    },
    //监控data中的数据变化
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    methods: {
        handleCurrentChange(index) {
            this.query.pageIndex = index;
            this.getRequest();
        },

        // 获取列表数据
        getRequest() {
            let {
                query: { pageIndex, pageSize },
                keyWord,
                searchType,
                dateRangeTime,
                searchTypeList,
            } = this;
            let ajaxData = {
                pageIndex,
                pageSize,
                type: searchType, //查询类型：全店查询为1，单产品查询为2，关键词查询为3
                keyWord, //查询关键词
            };
            if (dateRangeTime) {
                ajaxData.startTime = dayjs(dateRangeTime[0]).format('YYYY-MM-DD') + ' 00:00:00';
                ajaxData.endTime = dayjs(dateRangeTime[1]).format('YYYY-MM-DD') + ' 23:59:59';
            }
            this.loading = true;
            this.$ajax.post('fw/api/v1/RankedQuery/Search', ajaxData).then((res) => {
                this.loading = false;
                let { code, msg, result } = res;
                if (code !== 200) {
                    return this.this.$message.warning(msg);
                }
                result.list.forEach((el) => {
                    el.queryTypeText = searchTypeList.find((v) => v.value === el.queryType)?.label ?? '--';
                });
                this.tableData = result.list;
                this.query.totalCount = result.totalCount;
            });
        },

        search() {
            this.query.pageIndex = 1;
            this.getRequest();
        },

        // 查看详情
        checkDetail(row) {
            this.$refs.checkDetail.show(row);
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getRequest();
    },
};
</script>

<style lang="scss" scoped>
//@import url()
.queryRecord {
    .query-Record-content {
        padding: 20px;
        background: #fff;
    }
}
</style>
<style lang="scss">
.queryRecord {
    .query-Record-content {
        .el-date-editor .el-range-separator {
            width: initial;
        }
    }
}
</style>
